import { useMemo } from 'react';
import { HANDLE_SIZE } from '../../plot/utils/graph.utils';
import { useRuler2dDimensions } from '../hooks/useRuler2dDimensions';
import { useUpdateByBoundary } from '../hooks/useUpdateByBoundary';

export const edges = ['top', 'bottom', 'left', 'right'] as const;
export type Edge = typeof edges[number];

interface Props {
  edge: Edge;
}

export const Ruler2dResizeEdgeHandle: React.FC<Props> = ({ edge }) => {
  const updateByBoundary = useUpdateByBoundary();
  const { x, y, height, width } = useRuler2dDimensions();
  const cursor = useMemo(() => {
    switch (edge) {
      case 'top':
      case 'bottom':
        return 'ns-resize';
      case 'left':
      case 'right':
        return 'ew-resize';
    }
  }, [edge]);

  const onMouseDown = (event: React.MouseEvent<SVGRectElement>) => {
    switch (edge) {
      case 'left':
        updateByBoundary(event, 'xBoundary', 'timestampStart');
        break;
      case 'right':
        updateByBoundary(event, 'xBoundary', 'timestampEnd');
        break;
      case 'top':
        updateByBoundary(event, 'yBoundary', 'voltageStart');
        break;
      case 'bottom':
        updateByBoundary(event, 'yBoundary', 'voltageEnd');
        break;
    }
  };

  const xHandle = edge === 'right' ? x + width : x;
  const yHandle = edge === 'bottom' ? y + height : y;
  const widthHandle = edge === 'left' || edge === 'right' ? HANDLE_SIZE : width;
  const heightHandle =
    edge === 'top' || edge === 'bottom' ? HANDLE_SIZE : height;

  return (
    <rect
      data-testid={`ruler2d-${edge}-handle`}
      fill='transparent'
      opacity={0.3}
      x={xHandle - HANDLE_SIZE / 2}
      y={yHandle - HANDLE_SIZE / 2}
      width={widthHandle}
      height={heightHandle}
      cursor={cursor}
      onMouseDown={(event) => {
        onMouseDown(event);
      }}
    />
  );
};
